export const HOME = '/'
export const STORE = '/store'
export const ADMIN = '/admin'
export const VIDEO = '/v/:short_code'
export const UPLOAD = '/upload'
export const VIDEO_STATUS = '/video_status/:short_code'
export const PROFILE = '/u/:username/'
export const PROFILE_VID = '/u/:username/v/:short_code'
export const SUCCESS = '/success'
export const FORGOT_PASSWORD = '/forgot_password'
export const CHANGE_PASSWORD = '/change_password'
export const MAGIC_LOGIN = '/auth/'
export const LIKES = '/likes/'
export const LIKES_VID = '/likes/v/:short_code'
export const CRYPTO = '/crypto'
